// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pagination Controls */
.pagination-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
  }
  .pagination-container {
    display: flex;
    justify-content: center; /* Center pagination */
    padding: 20px 0; /* Add padding */
  }
  
  .pagination-button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 38px;
    height: 38px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background-color: #fff;
    color: #4b5563;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
  }
  
  .pagination-button:hover:not(:disabled) {
    background-color: #f1f5f9;
    transform: translateY(-2px);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .pagination-button:active:not(:disabled) {
    transform: translateY(0);
  }
  
  .pagination-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .pagination-button.active {
    background-color: #1e3a8a;
    color: white;
    border-color: #1e3a8a;
    font-weight: 600;
    position: relative;
  }
  
  .pagination-button.active:before {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 16px;
    height: 2px;
    background-color: #7cc133;
    border-radius: 2px;
  }
  
  .pagination-icon {
    font-size: 18px;
    line-height: 1;
  }
  
  .pagination-info {
    margin-left: 12px;
    font-size: 14px;
    color: #64748b;
    white-space: nowrap;
  }
  
  /* Media query for tablet */
  @media (max-width: 768px) {
    .pagination-controls {
      flex-wrap: wrap;
      justify-content: center;
    }
    
    .pagination-info {
      width: 100%;
      text-align: center;
      margin-top: 8px;
      margin-left: 0;
    }
  }
  
  /* Media query for mobile */
  @media (max-width: 576px) {
    .pagination-controls {
      padding: 8px;
      gap: 4px;
    }
    
    .pagination-button {
      min-width: 32px;
      height: 32px;
      font-size: 13px;
    }
    
    .first-page, .last-page {
      display: none;
    }
  }
  
  /* Hover and focus styles for better accessibility */
  .pagination-button:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(30, 58, 138, 0.3);
  }
  
  /* Animation for page transitions */
  @keyframes pageTransition {
    0% { opacity: 0; transform: translateY(5px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  
  .pagination-button.active {
    animation: pageTransition 0.3s ease-out;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Admin Dashboard/PaginationStyles.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,uBAAuB,EAAE,sBAAsB;IAC/C,eAAe,EAAE,gBAAgB;EACnC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;EAC1C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;IACE;MACE,eAAe;MACf,uBAAuB;IACzB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,eAAe;MACf,cAAc;IAChB;EACF;;EAEA,2BAA2B;EAC3B;IACE;MACE,YAAY;MACZ,QAAQ;IACV;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA,oDAAoD;EACpD;IACE,aAAa;IACb,4CAA4C;EAC9C;;EAEA,mCAAmC;EACnC;IACE,KAAK,UAAU,EAAE,0BAA0B,EAAE;IAC7C,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC/C;;EAEA;IACE,uCAAuC;EACzC","sourcesContent":["/* Pagination Controls */\r\n.pagination-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    padding: 12px;\r\n    background-color: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\r\n    transition: all 0.3s ease;\r\n  }\r\n  .pagination-container {\r\n    display: flex;\r\n    justify-content: center; /* Center pagination */\r\n    padding: 20px 0; /* Add padding */\r\n  }\r\n  \r\n  .pagination-button {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 38px;\r\n    height: 38px;\r\n    border-radius: 8px;\r\n    border: 1px solid #e2e8f0;\r\n    background-color: #fff;\r\n    color: #4b5563;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    padding: 0;\r\n  }\r\n  \r\n  .pagination-button:hover:not(:disabled) {\r\n    background-color: #f1f5f9;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .pagination-button:active:not(:disabled) {\r\n    transform: translateY(0);\r\n  }\r\n  \r\n  .pagination-button:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .pagination-button.active {\r\n    background-color: #1e3a8a;\r\n    color: white;\r\n    border-color: #1e3a8a;\r\n    font-weight: 600;\r\n    position: relative;\r\n  }\r\n  \r\n  .pagination-button.active:before {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 16px;\r\n    height: 2px;\r\n    background-color: #7cc133;\r\n    border-radius: 2px;\r\n  }\r\n  \r\n  .pagination-icon {\r\n    font-size: 18px;\r\n    line-height: 1;\r\n  }\r\n  \r\n  .pagination-info {\r\n    margin-left: 12px;\r\n    font-size: 14px;\r\n    color: #64748b;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  /* Media query for tablet */\r\n  @media (max-width: 768px) {\r\n    .pagination-controls {\r\n      flex-wrap: wrap;\r\n      justify-content: center;\r\n    }\r\n    \r\n    .pagination-info {\r\n      width: 100%;\r\n      text-align: center;\r\n      margin-top: 8px;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  \r\n  /* Media query for mobile */\r\n  @media (max-width: 576px) {\r\n    .pagination-controls {\r\n      padding: 8px;\r\n      gap: 4px;\r\n    }\r\n    \r\n    .pagination-button {\r\n      min-width: 32px;\r\n      height: 32px;\r\n      font-size: 13px;\r\n    }\r\n    \r\n    .first-page, .last-page {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  /* Hover and focus styles for better accessibility */\r\n  .pagination-button:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 2px rgba(30, 58, 138, 0.3);\r\n  }\r\n  \r\n  /* Animation for page transitions */\r\n  @keyframes pageTransition {\r\n    0% { opacity: 0; transform: translateY(5px); }\r\n    100% { opacity: 1; transform: translateY(0); }\r\n  }\r\n  \r\n  .pagination-button.active {\r\n    animation: pageTransition 0.3s ease-out;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
